import React from "react";
import LoadingInput from "../../../../_components/LoadingInput";
import Text from "../../../../_components/Text";
import Button from "../../../../_components/Button";
import Modal from "../../../../_components/Modal";
import {
    createUnit,
    updateUnit,
} from "../../../../api/products";
import { toast } from "react-toastify";

export default (props) => {
    const ref = React.useRef();
    const [id, setId] = React.useState("");
    const [name, setName] = React.useState("");
    const [loading, setLoading] = React.useState(false);

    function onSave() {
        if (!name.trim()) return;

        if (props.existingItems) {
            const exists = props.existingItems.find(item => 
                item.name.toLowerCase() === name.trim().toLowerCase() && 
                (!props.edit || item.id !== props.edit.id)
            )
            if (exists) {
                toast.warn("Já existe uma unidade com esse nome!", { position: "top-center" })
                return
            }
        }

        if (loading) {
            return;
        }
        setLoading(true);
        const request = () => {
            return props.edit ? updateUnit(id, { name }) : createUnit({ name })
        } 
        request()
            .then((resp) => {
                setTimeout(() => {
                    if (props.onSave) {
                        props.onSave(resp)
                    }
                    setLoading(false);
                    setName("");
                    setId("")
                    if(props.onHide){
                        props.onHide()
                    }
                }, 400);

            })
            .catch((error) => { setLoading(false) });
    }

    React.useEffect(() => {
        if(props.show && props.edit) {
            setName(props.edit.name)
            setId(props.edit.id)
        }
    }, [props.show, props.edit])

    return (
        <Modal
            title="Unidade de Medida"
            show={props.show}
            onHide={() => {
                setName("")
                setId("")
                if(props.onHide){
                    props.onHide()
                }
            }}
        >
            <div className="container">
                <div className="row">
                    <div className="col-md-12 col-xs-12">
                        <div className="form-group">
                            <div className="form-label">
                                <Text color="primary">Nome da Unidade de Medida</Text>
                            </div>
                            <LoadingInput
                                name="name"
                                loading={loading}
                                value={name}
                                onChange={(e) => setName(e.target.value)}
                            />
                        </div>
                        <Button disabled={loading || name.length < 1} onClick={onSave}>
                            {props.edit? "Editar":"Cadastrar"}
                        </Button>
                    </div>
                </div>
            </div>
        </Modal>
    )
}



// WEBPACK FOOTER //
// ./src/views/AppViews/Products/Units/createEditModal.jsx